module.exports = __webpack_public_path__ + "img/logoArendal.e7c0032d.png";